/**
 * @erp/rpc - Contract-first RPC definitions
 *
 * This package provides type-safe RPC contracts that can be shared
 * between frontend and backend applications.
 */

// Export the main contract router
export { contractRouter } from "./contracts";

// Export all contract definitions
export * from "./contracts";

// Export all schemas
export * from "./schemas/common";

// Export all types
export * from "./types";

// Batching config
export const RPC_BATCH_MAX_SIZE = 10;

// MCP tool copy shared by backend and frontend
export * from "./mcp/toolCopy";
